<template>
  <v-footer color="#F7F7F7" class="pa-4">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <div class="d-flex flex-column flex-sm-row justify-center align-center text-caption text-sm-body-2">
            <span class="mb-2 mb-sm-0">
              Copyright &copy; 2014 
              <a href="#" class="text-decoration-none">Borneo Parking Systems Sdn Bhd</a>
            </span>
            <span class="d-none d-sm-inline mx-2">|</span>
            <span>
              Designed by 
              <a href="https://codesquad.com.my" class="text-decoration-none" target="_blank">Codesquad Devs PLT</a>
            </span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>